import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { processHTMLTranslations } from "@utils/htmlTranslationProcessor";

export const useTranslatedHTML = (html: string | undefined): string => {
  const { t, i18n } = useTranslation();
  const [translatedHTML, setTranslatedHTML] = useState("");

  useEffect(() => {
    if (!html) {
      setTranslatedHTML("");
      return;
    }

    const processed = processHTMLTranslations(html, t);
    setTranslatedHTML(processed);
  }, [html, t, i18n.language]);

  return translatedHTML;
};
